/** @format */

import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { Select, message, Table, Tooltip } from "antd";
import moment from "moment";
import {
	GetContactUs,
	UpdateContactUsStatus,
} from "../../../services/Api/ContentApi";

const ContactUs = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [selectedStatus, setSelectedStatus] = useState({});

	const columns = [
		{
			title: "S.No.",
			dataIndex: "index",
			width: "5%",
		},
		{
			title: "Name",
			dataIndex: "name",
			width: "10%",
		},
		{
			title: "Email",
			dataIndex: "email",
			width: "25%",
		},
		{
			title: "Query",
			dataIndex: "query",
			width: "30%",
			render: (text) => {
				if (!text) return "---";

				const shortText = text.length > 50 ? `${text.slice(0, 50)}...` : text;

				return (
					<Tooltip title={text} placement="topLeft">
						<span style={{ cursor: "pointer" }}>{shortText}</span>
					</Tooltip>
				);
			},
		},

		{
			title: "Date Submitted",
			dataIndex: "created_at",
			width: "20%",
			render: (date) =>
				date ? moment(date).format("DD MMM YYYY, hh:mm A") : "---",
		},
		{
			title: "Status",
			dataIndex: "status",
			width: "10%",
			render: (status, record) => {
				const currentStatus = selectedStatus[record.id] || status;

				const handleChange = async (value) => {
					try {
						message.loading({
							content: "Updating status...",
							key: "status",
						});

						await UpdateContactUsStatus(
							{
								contact_us_id: record.id,
								status: value,
							},
							localStorage.getItem("adminToken"),
						);

						setSelectedStatus((prev) => ({
							...prev,
							[record.id]: value,
						}));

						message.success({
							content: "Status updated successfully",
							key: "status",
						});
					} catch (err) {
						message.error({
							content: "Failed to update status",
							key: "status",
						});
					}
				};

				const statusColor =
					currentStatus === "resolved" ? "#2e7d32" : "#1565c0"; // green / blue

				return (
					<Select
						value={currentStatus}
						style={{
							width: 120,
							color: statusColor,
							fontWeight: 600,
						}}
						onChange={handleChange}
						dropdownStyle={{ textTransform: "capitalize" }}
					>
						<Select.Option value="pending">
							<span style={{ color: "#1565c0", fontWeight: 600 }}>Pending</span>
						</Select.Option>

						<Select.Option value="resolved">
							<span style={{ color: "#2e7d32", fontWeight: 600 }}>
								Resolved
							</span>
						</Select.Option>
					</Select>
				);
			},
		},
	];

	const getData = async () => {
		try {
			setLoading(true);
			const result = await GetContactUs(localStorage.getItem("adminToken"));

			const formatted = result.data.data?.map((item, index) => ({
				...item,
				index: index + 1,
			}));

			setData(formatted);
		} catch (error) {
			message.error("Failed to load contact queries");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<Box>
			<Box marginBottom="20px">
				<h3 className="page-title">CONTACT US</h3>
				<p className="page-sub-title">View and manage customer queries</p>
			</Box>

			<Table
				columns={columns}
				rowKey="id"
				dataSource={data}
				loading={loading}
				pagination={{ pageSize: 10 }}
			/>
		</Box>
	);
};

export default ContactUs;
